import { ref } from 'vue';
const vehicleTypes = ref([]);
const isLoading = ref(false);
const error = ref(null);
export function useVehicleTypes() {
    const setVehicleTypes = (types) => {
        vehicleTypes.value = types;
        error.value = null;
    };
    const clearVehicleTypes = () => {
        vehicleTypes.value = [];
        error.value = null;
    };
    const setLoading = (loading) => {
        isLoading.value = loading;
    };
    const setError = (err) => {
        error.value = err;
        vehicleTypes.value = [];
    };
    return {
        vehicleTypes,
        isLoading,
        error,
        setVehicleTypes,
        clearVehicleTypes,
        setLoading,
        setError
    };
}
